import DownloadLoader from "./downloadLoader";

export default DownloadLoader;
